import Vue from "vue";
import Vuex from "vuex";
import store from "./store/index";
import VueTinySlider from "vue-tiny-slider";
import SubmissionsFilter from "./components/SubmissionsFilter.vue";
import SubmissionsDocuments from "./components/SubmissionsDocuments.vue";
import SearchApp from "./components/search/SearchApp.vue";

/**
 * Set the wizard config context based on the wizardConfig Object which is set on the WizardPage.ss of the brand website
 * **/
function hydrateApp() {
  let viewContent = window.pageContent ? window.pageContent : {};
  let searchOptions = window.searchOptions ? window.searchOptions : {};
  // let pageConfig = window.pageConfig ? window.pageConfig : {};

  store.commit("updateField", {
    path: "viewContent",
    value: viewContent,
  });
  // store.commit("updateField", {
  //   path: "config.baseUrl",
  //   value: pageConfig.baseUrl,
  // });

  store.commit("updateField", {
    path: "searchApp.searchOptions",
    value: searchOptions,
  });
}

/**
 * Set up config
 * **/
function init() {
  hydrateApp();

  new Vue({
    el: "#app",
    data: {
      mainMenuOpen: false,
      childMenuOpenID: 0,
      timeout: null,
      partnersPanelOpen: false,
      globalSearchText: "",
      // headLinkChildMenuOpenID: 0,
      // animationTrigger: '',
    },
    components: {
      "tiny-slider": VueTinySlider,
      "submissions-filter": SubmissionsFilter,
      "submissions-documents": SubmissionsDocuments,
      "search-app": SearchApp,
      // "menu-item": MenuItem,
      // "child-menu-item": ChildMenuItem,
      // accordion: Accordion,
      // "vue-tiny-slider": VueTinySlider,
      // "headlink-menu-item": HeadlinkMenuItem,
      // "headlink-child-menu-item": HeadlinkChildMenuItem,
    },
    store,
    methods: {
      toggleMainMenu: function () {
        this.mainMenuOpen = !this.mainMenuOpen;
        // if menu closed, close children as well
        if (!this.mainMenuOpen) {
          this.childMenuOpenID = 0;
        }
      },
      toggleChildMenu: function (childMenuOpenID) {
        // this.childMenuActive = !this.childMenuActive;
        // check if we're opening or closing menu
        if (this.childMenuOpenID === childMenuOpenID) {
          // close if is current open
          this.childMenuOpenID = 0;
        } else {
          this.childMenuOpenID = childMenuOpenID;
        }

        // open main menu if not open
        if (!this.mainMenuOpen) {
          this.mainMenuOpen = true;
        }
      },
      childMenuActive(id) {
        if (this.childMenuOpenID === id) {
          return true;
        }
        return false;
      },
      expandPartnersPanel() {
        this.partnersPanelOpen = !this.partnersPanelOpen;
      },
      doGlobalSearch() {
        var url =
          window.location.origin +
          "/search?searchText=" +
          this.globalSearchText +
          "&category=all&sort=";
        window.location.href = url;
      },
    },
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});
